import { createContext } from "react";

const MksChatContext = createContext();

export default MksChatContext;
